import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["count", "result"]

  connect() {
    this.recalculate()
  }

  recalculate() {
    const partAPositiveCount = this.partAQuestionNumbers().filter((questionNumber) => {
      const checked = this.checkedInputFor(questionNumber)
      if (!checked) return false

      const positiveResponses = (checked.dataset.asrsScorePositiveResponses || "").split(",")
      return positiveResponses.includes(checked.value)
    }).length

    this.countTarget.textContent = String(partAPositiveCount)
    this.resultTarget.textContent =
      partAPositiveCount >= 4 ?
        "Positive screen for further ADHD evaluation" :
        "Below positive-screen threshold"
  }

  partAQuestionNumbers() {
    const inputs = this.element.querySelectorAll('input[data-asrs-score-part="Part A"]')
    return [...new Set(Array.from(inputs).map((input) => input.dataset.asrsScoreQuestionNumber))]
  }

  checkedInputFor(questionNumber) {
    return this.element.querySelector(`input[name="asrs_form[responses][${questionNumber}]"]:checked`)
  }
}
